import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { getStoredAuthToken } from '@/modules/auth/utils/authToken';
import { resolveApiBaseUrl } from '@/services/apiBaseUrl';

// Opt-in realtime debugging. Pusher's own logToConsole prints every socket
// state change, subscription and auth round-trip, which drowned out real
// warnings in the dev console on every page load. It is genuinely useful when
// debugging websockets, so it stays available - just no longer on by default.
// Enable with NEXT_PUBLIC_DEBUG_ECHO=true.
const isEchoDebugEnabled = process.env.NEXT_PUBLIC_DEBUG_ECHO === 'true';

// Required for Pusher
if (typeof window !== 'undefined') {
  (window as any).Pusher = Pusher;
  if (isEchoDebugEnabled) {
    (Pusher as any).logToConsole = true;
  }
}

const createEchoInstance = () => {
  if (typeof window === 'undefined') return null;

  const token = getStoredAuthToken();
  const pusherKey = process.env.NEXT_PUBLIC_PUSHER_APP_KEY;
  const pusherCluster = process.env.NEXT_PUBLIC_PUSHER_APP_CLUSTER || 'mt1';
  // This whole factory only ever runs in the browser (guarded above), so
  // resolveApiBaseUrl() always resolves to NEXT_PUBLIC_BASE_URL here.
  const authEndpoint = `${resolveApiBaseUrl()}/api/broadcasting/auth`;

  if (isEchoDebugEnabled) {
    console.log('Echo Config:', {
      key: pusherKey,
      cluster: pusherCluster,
      authEndpoint,
    });
  }

  if (!pusherKey) {
    console.warn('Echo: NEXT_PUBLIC_PUSHER_APP_KEY is not defined.');
    return null;
  }

  return new Echo({
    broadcaster: 'pusher',
    key: pusherKey,
    cluster: pusherCluster,
    forceTLS: true,
    authEndpoint,
    auth: {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        Accept: 'application/json',
      },
    },
  });
};

let echoInstance: Echo<'pusher'> | null = null;

export const getEcho = () => {
  if (!echoInstance) {
    echoInstance = createEchoInstance();
  }
  return echoInstance;
};

export const refreshEcho = () => {
  echoInstance = createEchoInstance();
  return echoInstance;
};
